/**
 * Infinite Scroll Configuration
 * Centralized settings for virtual scrolling and data management
 */
const InfiniteScrollConfig = {
  // Data fetching
  BATCH_SIZE: 15,
  PREFETCH_THRESHOLD: 0.8, // Trigger prefetch at 80% through loaded content
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // ms

  // Container pool
  MAX_CONTAINERS: 50,
  INITIAL_ANIMATION_COUNT: 8,

  // Dimensions
  ITEM_HEIGHT_DESKTOP: 320,
  ITEM_HEIGHT_MOBILE: 255,
  MOBILE_BREAKPOINT: 750,

  // Scroll handling
  SCROLL_THROTTLE_DELAY: 16 * 4, // 4x slower than ~60fps
  SCROLL_END_DELAY: 150, // ms
  SCROLL_RESTORE_RETRY_ATTEMPTS: 9, // Retry attempts for scroll restoration

  // Grid columns
  COLUMNS_DESKTOP: 4,
  COLUMNS_MOBILE: 2,

  // Cache — bump the prefix when the slimmed-product shape changes so stale
  // sessionStorage entries are ignored (v2: custom sellable availability).
  CACHE_PREFIX: "cache2:",
  MAX_CACHE_SIZE: 4 * 1024 * 1024, // 4MB
};

// Export for module usage
if (typeof module !== "undefined" && module.exports) {
  module.exports = InfiniteScrollConfig;
}
